import { createIcon } from '@chakra-ui/icons';

export const Archive = createIcon({
  displayName: 'Archive',
  viewBox: '0 0 12 12',
  d: 'M10.625 12.125H0.625V5.25H1.875V10.875H9.375V5.25H10.625V12.125ZM0 0.875H11.25V4.625H0V0.875ZM4.0625 5.875H7.1875C7.3625 5.875 7.5 6.0125 7.5 6.1875V7.125H3.75V6.1875C3.75 6.0125 3.8875 5.875 4.0625 5.875ZM1.25 2.125V3.375H10V2.125H1.25Z',
});
